import { render, staticRenderFns } from "./ProductItem2.vue?vue&type=template&id=5f8626eb&scoped=true&"
import script from "./ProductItem2.vue?vue&type=script&lang=js&"
export * from "./ProductItem2.vue?vue&type=script&lang=js&"
import style0 from "./ProductItem2.vue?vue&type=style&index=0&id=5f8626eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8626eb",
  null
  
)

export default component.exports